import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import { TooltipLoader } from '../../global/TooltipLoader';
import { FormattedMessage } from 'react-intl';
import PrintIcon from 'dibs-icons/exports/Print';

// redux actions
import { printActions } from '../../actions/pdpRespPrintActions';

// helpers
import { trackPrintNoPriceClick, trackPrintWithPriceClick } from '../tracking/iconBubblesTracking';

import styles from './PdpRespIconBubbles.scss';

// messages
const print = <FormattedMessage id="PdpRespIconBubblePrint.print" defaultMessage="Print" />;
const printNoPrice = (
    <FormattedMessage
        id="PdpRespIconBubblePrint.printNoPrice"
        defaultMessage="Print without Price"
    />
);

// trade messages
const printTrade = (
    <FormattedMessage id="PdpRespIconBubblePrint.printTrade" defaultMessage="Print Tear Sheet" />
);
const printNoPriceTrade = (
    <FormattedMessage
        id="PdpRespIconBubblePrint.printNoPriceTrade"
        defaultMessage="Print Tear Sheet without Price"
    />
);

const TOOLTIP_HIDE_TIMEOUT = 200;

class PdpRespIconBubblePrintComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showTooltip: false };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.hideTooltipAfterTimeout = this.hideTooltipAfterTimeout.bind(this);
        this.onClickPrintWithPrice = this.onClickPrintWithPrice.bind(this);
        this.onClickPrintWithoutPrice = this.onClickPrintWithoutPrice.bind(this);
        this.getMouseProps = this.getMouseProps.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (this.props.pdpPrint.triggerWindowPrint && !prevProps.pdpPrint.triggerWindowPrint) {
            window.print();
            this.props.updateTriggerWindowPrint();
        }
    }
    showTooltip() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.setState({ showTooltip: true });
    }
    hideTooltip(cb) {
        this.setState({ showTooltip: false }, () => {
            // we want to update print with price / without price
            if (cb && typeof cb === 'function') {
                cb();
            }
        });
    }
    hideTooltipAfterTimeout() {
        this.timeout = setTimeout(() => this.hideTooltip(), TOOLTIP_HIDE_TIMEOUT);
    }
    onClickPrintWithPrice(e) {
        e.stopPropagation();
        trackPrintWithPriceClick();
        this.hideTooltip(() => this.props.updateToPrintWithPrice());
    }
    onClickPrintWithoutPrice(e) {
        e.stopPropagation();
        trackPrintNoPriceClick();
        this.hideTooltip(() => this.props.updateToPrintWithoutPrice());
    }
    getMouseProps(isTrade) {
        if (isTrade) {
            return {
                onMouseEnter: this.showTooltip,
                onMouseLeave: this.hideTooltipAfterTimeout,
            };
        }
        return {
            onClick: this.showTooltip,
        };
    }
    render() {
        const { showTooltip } = this.state;
        const { isTrade } = this.props;
        const tradeDataTnSuffix = isTrade ? '-trade' : '';

        return (
            <div
                className={`${styles.bubble} enable-click-on-preview`}
                data-tn="icon-bubble-print"
                {...this.getMouseProps(isTrade)}
            >
                {/* Print Icon */}
                <PrintIcon className={styles.icon} />

                {/* Tooltip */}
                <TooltipLoader
                    load={showTooltip}
                    isVisible={showTooltip}
                    closeOnOutsideClick
                    onClose={this.hideTooltip}
                >
                    <span
                        className={styles.printLink}
                        onClick={this.onClickPrintWithPrice}
                        data-tn={`print${tradeDataTnSuffix}`}
                    >
                        {isTrade ? printTrade : print}
                    </span>
                    <span
                        className={styles.printLink}
                        onClick={this.onClickPrintWithoutPrice}
                        data-tn={`print-no-price${tradeDataTnSuffix}`}
                    >
                        {isTrade ? printNoPriceTrade : printNoPrice}
                    </span>
                </TooltipLoader>
            </div>
        );
    }
}

PdpRespIconBubblePrintComponent.propTypes = {
    pdpPrint: PropTypes.shape({
        triggerWindowPrint: PropTypes.bool.isRequired,
    }).isRequired,
    updateToPrintWithPrice: PropTypes.func.isRequired,
    updateToPrintWithoutPrice: PropTypes.func.isRequired,
    updateTriggerWindowPrint: PropTypes.func.isRequired,
    isTrade: PropTypes.bool,
};

// Redux Map Functions
function mapStateToProps({ pdpPrint }) {
    return { pdpPrint };
}
function mapDispatchToProps(dispatch) {
    return {
        updateToPrintWithPrice: () => dispatch(printActions.printWithPrice()),
        updateToPrintWithoutPrice: () => dispatch(printActions.printWithoutPrice()),
        updateTriggerWindowPrint: () => dispatch(printActions.windowPrintTriggered()),
    };
}

export const PdpRespIconBubblePrint = connect(
    mapStateToProps,
    mapDispatchToProps
)(PdpRespIconBubblePrintComponent);
